// https://swiperjs.com/swiper-api#styles if you need to change the styles
// import 'swiper/css';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import Slider from '../classes/swiper';

const baseControls = (el) => ({
  pagination: { el: el.querySelector('.swiper-pagination') },
  navigation: {
    nextEl: el.querySelector('.swiper-button-next'),
    prevEl: el.querySelector('.swiper-button-prev'),
  },
});

// Standard
document.querySelectorAll('.general-swiper').forEach(function (element) {
  new Slider(element.querySelector('.swiper-init'), {
    modules: [Navigation, Pagination],
    grabCursor: true,
    slidesPerView: 1,
    spaceBetween: 20,
    watchOverflow: true,
    ...baseControls(element),
  });
});

// News
document.querySelectorAll('.news-swiper').forEach(function (element) {
  new Slider(element.querySelector('.swiper-init'), {
    modules: [Navigation, Pagination],
    grabCursor: true,
    slidesPerView: 1.15,
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    ...baseControls(element),
  });
});

// Project Slider
document.querySelectorAll('.project-swiper').forEach(function (element) {
  const card = element.closest('.project-slider__card');
  new Slider(element.querySelector('.swiper-init'), {
    modules: [Navigation, Pagination],
    grabCursor: true,
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 16,
    watchOverflow: true,
    navigation: {
      prevEl: [
        ...card.querySelectorAll(
          '.project-slider__nav--prev, .slider-controls__nav--prev',
        ),
      ],
      nextEl: [
        ...card.querySelectorAll(
          '.project-slider__nav--next, .slider-controls__nav--next',
        ),
      ],
    },
    pagination: {
      el: [
        ...card.querySelectorAll(
          '.slider-controls__pagination, .project-slider__pagination--desktop',
        ),
      ],
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
  });
});

// Products Slider
document.querySelectorAll('.products-swiper').forEach(function (element) {
  const block = element.closest('.block-products');
  new Slider(element.querySelector('.swiper-init'), {
    modules: [Navigation, Pagination],
    grabCursor: true,
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 16,
    watchOverflow: true,
    navigation: {
      prevEl: [...block.querySelectorAll('.slider-controls__nav--prev')],
      nextEl: [...block.querySelectorAll('.slider-controls__nav--next')],
    },
    pagination: {
      el: block.querySelector('.slider-controls__pagination'),
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    },
  });
});

// hero block with multiple slides
document.querySelectorAll('.block-hero__swiper').forEach(function (element) {
  const wrapper = element.closest('.block-hero__wrapper');
  new Slider(element.querySelector('.swiper-init'), {
    modules: [Pagination, Autoplay],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    watchOverflow: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: wrapper.querySelector('.block-hero__pagination'),
      clickable: true,
    },
  });
});

// USPS ticker — vertical autoplay, one item at a time
new Slider('.usps-swiper', {
  modules: [Autoplay],
  direction: 'vertical',
  loop: true,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});
